<template>
  <div>
    <section id="hero-usp">

      <div class="container">
        <div class="row text-left">
          <div class="col-xs-12 col-sm-5 mt-20">
            <h1 class="s1" style="font-weight: 600;">
              Join us at <br/> Big Data London
            </h1>

            <p class="white">
              Schedule a 1:1 intro chat with us to discuss your data challenges and
              opportunities.
            </p>

          </div>

          <div class="col-xs-12 col-sm-7">
            <lottie-animation
              path="animations/hero/data.json"
              :loop="true"
              :autoPlay="true"
              :speed="1"

            />

          </div>

        </div>
      </div>
    </section>

    <section class="feature-section">
      <div class="container">

        <div class="row">
          <div class="visible-sm visible-md visible-lg col-sm-5 text-left mt-40" style="min-height: 1200px;">
            <img src="/images/logos/big-data-london-logo-4-2023.png" alt="Big Data London Logo" class="mt-20 img-responsive"/>
            <p class="mt-40">Skippr solves the EL in ELT, discovering your schemas and optimising your data at ingestion.</p>
            <p>We’re your automated on-ramp to datalakes, streaming and data catalogs. With hands-free data ingestion
              and schema syncing, you can reliably query your data in minutes and share schemas to realise the Data
              Contract mission of the Data Mesh.</p>
            <p>Skippr guarantees backwards compatibility as your schemas evolve over time, while optimising your data
              for each downstream system. Driving down cloud and engineering cost, accelerating time to value.</p>
            <h2 class="s1 mt-40 mb-10">End “Rubbish in, Rubbish out”</h2>
            <p>Our mission is to end “Rubbish in, Rubbish out” and release our talented engineering and analyst friends
              to focus on deriving value from data, not getting bogged down in technical data preparation.</p>
            <p>Let the machines do the machine bit, and empower the people to create the value.</p>
          </div>
          <div class="col-sm-7" style="min-height: 1200px;">
            <vue-calendly url="https://calendly.com/skippr-paulh/15min?hide_gdpr_banner=1" :height="1200"></vue-calendly>
          </div>
        </div>

      </div>
    </section>

  </div>


</template>

<script>

import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

import Vue from 'vue';
import VueCalendly from 'vue-calendly';

Vue.use(VueCalendly);

export default {
  name: 'BigDataLondon',
  components: {
    LottieAnimation
  },
  props: {
    msg: String
  },
  head: {
    title: {
      inner: 'BigData London Meetup',
      separator: '-',
      complement: '15 Minute Intro Chat'
    },
    //omited
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
